import React from 'react';

function CrossIcon({ width = 14, height = 14, ...rest }) {
  // tslint:disable max-line-length
  return (
    <svg {...rest} width={width} height={height} viewBox="0 0 14 14">
      <g>
        <path d="M2.70710678,12.7569824 C2.31658249,13.1475067 1.68341751,13.1475067 1.29289322,12.7569824 C0.902368927,12.3664581 0.902368927,11.7332931 1.29289322,11.3427688 L11.3427688,1.29289322 C11.7332931,0.902368927 12.3664581,0.902368927 12.7569824,1.29289322 C13.1475067,1.68341751 13.1475067,2.31658249 12.7569824,2.70710678 L2.70710678,12.7569824 Z" />
        <path d="M0.792893219,2.20710678 C0.402368927,1.81658249 0.402368927,1.18341751 0.792893219,0.792893219 C1.18341751,0.402368927 1.81658249,0.402368927 2.20710678,0.792893219 L13.2071068,11.7928932 C13.5976311,12.1834175 13.5976311,12.8165825 13.2071068,13.2071068 C12.8165825,13.5976311 12.1834175,13.5976311 11.7928932,13.2071068 L0.792893219,2.20710678 Z" />
      </g>
    </svg>
  );
  // tslint:enable max-line-length
}

export default CrossIcon;
